import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import EditDetailsForm from "../../forms/EditDetailsForm.jsx";
import ProjectDetailsView from "./ProjectDetailsView.jsx";
import withBasicForm from "/components/forms/withBasicForm.js";
import EditButton from "../../forms/EditButton.jsx";

import { OPERATIONS } from "/constants/operations.js";
import { VIEW_MODES } from "/constants/modes.js";

import { selectOperationAvailability } from "/state/reducers/operations/operationSelector.js";
import { selectCopy } from "/state/reducers/locale/copySelector.js";

const BasicEditDetailsForm = withBasicForm(EditDetailsForm);

class ProjectDetailsPanel extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    doEdit: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "project.details_panel"
  };

  constructor(props) {
    super(props);

    this.state = {
      mode: VIEW_MODES.DISPLAY
    };
  }

  // -- EVENT HANDLERS -- //

  onEdit = () => {
    this.setState({ mode: VIEW_MODES.EDIT });
  };

  onCancel = () => {
    this.setState({ mode: VIEW_MODES.DISPLAY });
  };

  onSubmit = values => {
    const prepedValues = {
      ...values,
      requiresUserVerification: Boolean(values.requiresUserVerification)
    };
    this.props.doEdit(prepedValues);
  };

  // -- RENDER -- //

  renderPanelView() {
    if (this.state.mode === VIEW_MODES.EDIT) {
      return (
        <BasicEditDetailsForm
          {...this.props}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      );
    } else {
      return <ProjectDetailsView {...this.props} className="clear-both" />;
    }
  }

  render() {
    const { mode } = this.state;
    const {
      data,
      disabled,
      copyKey,
      copy,
      updateProjectAvailability: { available }
    } = this.props;

    if (!data) return null;

    return (
      <Segment className="clear-both" disabled={disabled}>
        <Header as="h3" floated="left">
          {copy(`${copyKey}.details`)}
        </Header>
        {available && (
          <EditButton
            mode={mode}
            floated="right"
            disabled={disabled}
            onClick={this.onEdit}
          />
        )}
        <span className="clearfix"></span>
        {this.renderPanelView()}
      </Segment>
    );
  }
}

const mapStateToProps = (state, props) => ({
  updateProjectAvailability: selectOperationAvailability(
    state,
    props,
    OPERATIONS.UPDATE
  ),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ProjectDetailsPanel);
